import { render } from "./examStartPrompty.vue?vue&type=template&id=a321aef2&scoped=true"
import script from "./examStartPrompty.vue?vue&type=script&lang=js"
export * from "./examStartPrompty.vue?vue&type=script&lang=js"

import "./examStartPrompty.vue?vue&type=style&index=0&id=a321aef2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a321aef2"]])

export default __exports__